import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Alert,
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Snackbar,
  Toolbar,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import theme from "assets/theme";
import MDButton from "components/MDButton";
import useLogout from "hooks/useLogout";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { AlertState } from "states";
import AuthContext from "../../store/auth-context";
import { AppEventTool } from "../../utils/appEventTool";
import LogoutDialog from "./LogoutDialog";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import DoorSlidingIcon from "@mui/icons-material/DoorSliding";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { PermissionMenuKey } from "../../utils/constants";
import { LinkImage } from "../../utils";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function TopHeader() {
  const location = useLocation();
  const route = location.pathname.split("/").slice(1);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [value, setValue] = useState(0);
  const [alert, setAlert] = useRecoilState(AlertState);
  useEffect(() => {
    const eventSearchTypeProject = AppEventTool.addListener(
      "searchCircleProject",
      (data) => {
        if (data && data?.type) {
          const { type, isSearching } = data;
          if (type == "duAn" && isSearching && value != 0) {
            setValue(0);
          }
        }
      }
    );
    return () => {
      eventSearchTypeProject?.remove();
    };
  }, [value]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const toggleSlider = (e) => {
    setShow(!show);
    AppEventTool.triggerEvent("clickChangeToggle", e);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    AppEventTool.triggerEvent("changetabs", true);
  };

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogoutClick = () => {
    isMobile && show && setShow(false);
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    onLogout();
    setLogoutDialogOpen(false);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const { accessToken, statusAuth, user, setStatusAuth } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    if (statusAuth === "logout" || statusAuth === null) {
      setIsAuthenticated(false);
    } else setIsAuthenticated(true);
  }, [statusAuth]);

  const navigateToSignIn = () => {
    navigate("/sign-in");
  };
  const navigateToManager = () => {
    navigate("/dashboard");
  };
  const logout = useLogout();

  async function onLogout() {
    await logout();
    navigate("/");
    setOpen(true);
    setStatusAuth("logout");
  }
  useEffect(() => {}, [onLogout]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState("");
  const handleClick = (key) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(key);
  };
  const handleNavigateData = (router) => {
    if (router === undefined) return;
    navigate(router);
    isMobile && show && setShow(false);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu("");
  };

  const menuCSDL = useMemo(
    () => [
      {
        key: PermissionMenuKey.home,
        title: "Trang chủ",
        icon: <HomeIcon />,
        route: "/",
      },
      {
        key: PermissionMenuKey.gioiThieu,
        title: "Giới thiệu",
        icon: <DoorSlidingIcon />,
        route: `/${PermissionMenuKey.gioiThieu}`,
        // children: [
        //   {
        //     key: PermissionMenuKey.baocaoDoanhNghiep,
        //     title: "DANH SÁCH DOANH NGHIỆP",
        //     icon: <PeopleAltIcon fontSize="small" />,
        //     isTargetBlank: true,
        //     indexRender: 1,
        //     route: `/baocaothongke/${PermissionMenuKey.baocaoDoanhNghiep}`,
        //   },
        // ]
      },
      {
        key: PermissionMenuKey.tinTuc,
        title: "Tin tức",
        icon: <NewspaperIcon />,
        route: `/${PermissionMenuKey.tinTuc}`,
      },
      {
        key: PermissionMenuKey.dangKyChuThe,
        title: "Đăng ký chủ thể",
        icon: <AssignmentIndIcon />,
        route: `/${PermissionMenuKey.dangKyChuThe}`,
      },
    ],
    []
  );

  return (
    <>
      {location.state && location.state.successMessage && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          onClose={handleClose}
          sx={{
            zIndex: 99999999,
          }}
        >
          <Alert onClose={handleClose} severity="success">
            {location.state.successMessage}
          </Alert>
        </Snackbar>
      )}
      {statusAuth === "logout" && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          onClose={handleClose}
          sx={{
            zIndex: 99999999,
          }}
        >
          <Alert onClose={handleClose} severity="success">
            Đăng xuất thành công
          </Alert>
        </Snackbar>
      )}
      <Box
        sx={{
          flexGrow: 1,
          position: show ? "static" : "sticky",
          top: 0,
          left: 0,
          zIndex: "999999",
        }}
      >
        <AppBar position="static" color="info" disablegutters="true">
          <Toolbar>
            <Typography
              variant="h6"
              color="#fff"
              component="div"
              sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
            >
              <img
                src={LinkImage.logo}
                alt="logo-ocop"
                width={164}
                height={164}
                className="mr-3 w-16 h-6"
                loading="lazy"
              />
              <span>PHẦN MỀM ĐÁNH GIÁ LƯU TRỮ HỒ SƠ OCOP</span>
            </Typography>
            {menuCSDL?.length > 0 &&
              (isMobile ? (
                <Box>
                  <IconButton
                    onClick={() => {
                      setShow(true);
                    }}
                    sx={{ color: "#ffffff" }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Drawer
                    anchor="right"
                    open={show}
                    onClose={() => {
                      setShow(false);
                    }}
                    sx={{
                      ".MuiDrawer-paper": {
                        margin: "0px !important",
                        height: "100vh !important",
                        borderRadius: "0px !important",
                      },
                    }}
                  >
                    <DrawerHeader>
                      <IconButton
                        onClick={() => {
                          setShow(false);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                      {menuCSDL.map((item, index) => (
                        <ListItem
                          key={item?.key + "menuMobile"}
                          disablePadding
                          onClick={(e) => handleNavigateData(item?.route)}
                        >
                          <ListItemButton>
                            <ListItemIcon>{item?.icon}</ListItemIcon>
                            <ListItemText primary={item?.title} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                    <Divider />
                    <List>
                      {accessToken && (
                        <ListItem key={"managerMenuMobile"} disablePadding>
                          <ListItemButton onClick={navigateToManager}>
                            <ListItemIcon>
                              <SettingsIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Trang quản trị"} />
                          </ListItemButton>
                        </ListItem>
                      )}
                      <ListItem key={"logMenuMobile"} disablePadding>
                        <ListItemButton
                          onClick={
                            accessToken ? handleLogoutClick : navigateToSignIn
                          }
                        >
                          <ListItemIcon>
                            {accessToken ? <LogoutIcon /> : <LoginIcon />}
                          </ListItemIcon>
                          <ListItemText
                            primary={accessToken ? "Đăng xuất" : "Đăng nhập"}
                          />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  </Drawer>
                </Box>
              ) : (
                <>
                  {menuCSDL?.map((menu, index) =>
                    menu?.children?.length > 0 ? (
                      <Fragment key={menu?.key + "menu" + index}>
                        <MDButton
                          variant="text"
                          size="small"
                          color="warning"
                          sx={{ mr: 2, color: "#ffffff" }}
                          // startIcon={menu?.icon}
                          onClick={handleClick(menu?.key)}
                          aria-controls={
                            openMenu == menu?.key ? "account-menu" : undefined
                          }
                          aria-haspopup={
                            menu?.children?.length > 0 ? true : false
                          }
                          aria-expanded={
                            openMenu == menu?.key ? "true" : undefined
                          }
                          endIcon={
                            menu?.children?.length > 0 ? (
                              <KeyboardArrowDownIcon />
                            ) : (
                              <></>
                            )
                          }
                        >
                          {menu &&
                            menu.title &&
                            menu?.title?.toLocaleUpperCase()}
                        </MDButton>
                        <Menu
                          anchorEl={anchorEl}
                          id="account-menu"
                          open={openMenu == menu?.key}
                          onClose={handleCloseMenu}
                          onClick={handleCloseMenu}
                          transformOrigin={{
                            horizontal: "right",
                            vertical: "top",
                          }}
                          anchorOrigin={{
                            horizontal: "right",
                            vertical: "bottom",
                          }}
                        >
                          {menu?.children?.length > 0 &&
                            menu.children.map((child, index) =>
                              child.divider ? (
                                <MenuItem
                                  divider
                                  key={"divider_item_children_" + index}
                                />
                              ) : child?.isDefault ? (
                                <MenuItem
                                  component="a"
                                  href={child.route}
                                  target="_blank"
                                  key={child.key}
                                >
                                  <ListItemIcon>{child?.icon}</ListItemIcon>
                                  {child?.title?.toLocaleUpperCase()}
                                </MenuItem>
                              ) : (
                                <MenuItem
                                  onClick={(e) =>
                                    handleNavigateData(child.route)
                                  }
                                  key={child.key}
                                >
                                  <ListItemIcon>{child?.icon}</ListItemIcon>
                                  {child?.title?.toLocaleUpperCase()}
                                </MenuItem>
                              )
                            )}
                        </Menu>
                      </Fragment>
                    ) : (
                      <MDButton
                        key={menu?.key + "menu" + index}
                        variant="text"
                        size="small"
                        color="warning"
                        sx={{
                          mr: 2,
                          color:
                            route[0] == menu?.key ||
                            (location.pathname === "/" && index == 0)
                              ? "#fb8c00"
                              : "#ffffff",
                        }}
                        onClick={(e) => handleNavigateData(menu?.route)}
                      >
                        {menu && menu.title && menu?.title?.toLocaleUpperCase()}
                      </MDButton>
                    )
                  )}
                  {!accessToken && (
                    <Tooltip title={"Đăng nhập"} placement="bottom">
                      <IconButton
                        size="small"
                        color="primary"
                        sx={{
                          backgroundColor: "#ffffff",
                          padding: "0.5rem",
                          "&:hover": {
                            backgroundColor: "#ffffff",
                            boxShadow: "0px 1px 10px #d6d6d6",
                          },
                        }}
                        onClick={navigateToSignIn}
                      >
                        {<LoginIcon />}
                      </IconButton>
                    </Tooltip>
                  )}
                  {accessToken && (
                    <>
                      <MDButton
                        variant="text"
                        size="small"
                        color="warning"
                        sx={{ mr: 2, color: "#ffffff" }}
                        onClick={navigateToManager}
                      >
                        Trang Quản trị
                      </MDButton>
                      <Tooltip title={"Đăng xuất"} placement="bottom">
                        <IconButton
                          size="small"
                          color="error"
                          sx={{
                            backgroundColor: "#ffffff",
                            padding: "0.5rem",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              boxShadow: "0px 1px 10px #d6d6d6",
                            },
                          }}
                          onClick={handleLogoutClick}
                        >
                          {<LogoutIcon />}
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              ))}
          </Toolbar>
        </AppBar>
        <LogoutDialog
          open={logoutDialogOpen}
          onClose={handleLogoutCancel}
          onLogout={handleLogoutConfirm}
        />
        {/* <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            marginTop: "4rem",
          }}
        >
          <Box sx={{ flexGrow: 1 }}>content</Box>
          <Box
            height={"2rem"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{
              backgroundColor: "#1A73E8",
              color: "#ffffff",
              fontSize: "0.75rem",
            }}
          >
            {`Bản quyền © OCOP năm ${new Date().getFullYear()}`}
          </Box>
        </Box> */}
      </Box>
    </>
  );
}
